import axios from 'axios';
import {toast} from 'react-toastify';
import moment from 'moment';
import {GET_STOCK_TRANSFER_LIST, SAVE_STOCK_TRANSFER, DELETE_STOCK_TRANSFER, STOCK_TRANSFER_ERROR} from './actionTypes';
import {errorHandlers} from '../../helpers/errorHandlers';
import {loaderStart, loaderStop} from '../actions';

const BASE = 'StockTransfer/';

export const getStockTransferById = (id, onSuccess) => async (dispatch) => {
  dispatch(loaderStart());
  axios
    .get(BASE + 'GetById?id=' + id)
    .then((res) => {
      dispatch(loaderStop());
      onSuccess && onSuccess(res);
    })
    .catch((error) => {
      errorHandlers(error);
      dispatch(loaderStop());
    });
};

export const getStockTransferList = (date) => async (dispatch) => {
  dispatch(loaderStart());
  const fromDate = moment(date[0]).format('YYYY-MM-DD');
  const toDate = moment(date[1]).format('YYYY-MM-DD');
  axios
    .get(BASE + 'GetList?fromDate=' + fromDate + '&toDate=' + toDate)
    .then((res) => {
      res.map((a) => {
        a.date = moment(a.stockTransferDate).format('DD/MM/YYYY');
      });
      dispatch(loaderStop());
      dispatch({type: GET_STOCK_TRANSFER_LIST, payload: res});
    })
    .catch((error) => {
      errorHandlers(error);
      dispatch(loaderStop());
      dispatch({type: STOCK_TRANSFER_ERROR, payload: error?.response?.data?.errorMessage || 'Failed'});
    });
};

export const saveStockTransfer = (payload, onSuccess) => async (dispatch) => {
  dispatch(loaderStart());
  axios
    .post(BASE + 'SaveStockTransfer', payload)
    .then(() => {
      toast.success(payload.stockTransferId ? 'Stock Transfer updated successfully' : 'Stock Transfer saved successfully');
      dispatch(loaderStop());
      dispatch({type: SAVE_STOCK_TRANSFER});
      onSuccess && onSuccess();
    })
    .catch((error) => {
      errorHandlers(error);
      dispatch(loaderStop());
      dispatch({type: STOCK_TRANSFER_ERROR, payload: error?.response?.data?.errorMessage || 'Failed'});
    });
};

export const deleteStockTransfer = (row) => async (dispatch) => {
  dispatch(loaderStart());
  const detailList = (row.stockTransferDetailList || []).map((d) => ({...d, operationToPerform: 3}));
  const payload = {...row, operationToPerform: 3, stockTransferDetailList: detailList};
  axios
    .post(BASE + 'DeleteStockTransfer/' + row.stockTransferId, payload)
    .then(() => {
      toast.success('Stock Transfer deleted successfully');
      dispatch(loaderStop());
      dispatch({type: DELETE_STOCK_TRANSFER});
    })
    .catch((error) => {
      errorHandlers(error);
      dispatch(loaderStop());
      dispatch({type: STOCK_TRANSFER_ERROR, payload: error?.response?.data?.errorMessage || 'Failed'});
    });
};
